type CommentReportIconProps = {
  size?: number;
  color?: string;
  className?: string;
};

export const CommentReportIcon = ({ size = 15, color = "#176BF2", className }: CommentReportIconProps) => {
  return (
    <svg
      width={size}
      height={Math.round((size * 17) / 15)} // Maintain aspect ratio (15:17)
      viewBox="0 0 15 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1_167396)">
        <path
          d="M10.3645 15.8962C8.44933 15.8962 6.89258 14.3379 6.89258 12.4227C6.89258 10.5075 8.45089 8.94922 10.3645 8.94922C12.2781 8.94922 13.838 10.5075 13.838 12.4227C13.838 14.3379 12.2797 15.8962 10.3645 15.8962ZM10.3645 10.0728C9.06798 10.0728 8.01456 11.1277 8.01456 12.4227C8.01456 13.7176 9.06954 14.7726 10.3645 14.7726C11.6594 14.7726 12.7144 13.7176 12.7144 12.4227C12.7144 11.1277 11.6594 10.0728 10.3645 10.0728Z"
          fill={color}
        />
        <path
          d="M13.9391 16.5581C13.7958 16.5581 13.6524 16.5036 13.5418 16.3945L12.0271 14.8798C11.8074 14.6601 11.8074 14.3048 12.0271 14.0867C12.2468 13.8669 12.6021 13.8669 12.8203 14.0867L14.335 15.6013C14.5547 15.8211 14.5547 16.1764 14.335 16.3945C14.2259 16.5036 14.0809 16.5581 13.9376 16.5581H13.9391Z"
          fill={color}
        />
        <path
          d="M9.61336 5.54093H4.53951C4.2294 5.54093 3.97852 5.29004 3.97852 4.97994C3.97852 4.66983 4.2294 4.41895 4.53951 4.41895H9.61336C9.92346 4.41895 10.1744 4.66983 10.1744 4.97994C10.1744 5.29004 9.92346 5.54093 9.61336 5.54093Z"
          fill={color}
        />
        <path
          d="M6.24704 16.5584H2.72994C1.50043 16.5584 0.5 15.558 0.5 14.3285V2.67232C0.5 1.44282 1.50043 0.442383 2.72994 0.442383H11.4222C12.6517 0.442383 13.6521 1.44282 13.6521 2.67232V7.60749C13.6521 7.91759 13.4012 8.16848 13.0911 8.16848C12.781 8.16848 12.5301 7.91759 12.5301 7.60749V2.67232C12.5301 2.06147 12.033 1.56437 11.4222 1.56437H2.72994C2.11908 1.56437 1.62198 2.06147 1.62198 2.67232V14.3285C1.62198 14.9393 2.11908 15.4364 2.72994 15.4364H6.24704C6.55715 15.4364 6.80803 15.6873 6.80803 15.9974C6.80803 16.3075 6.55715 16.5584 6.24704 16.5584Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_167396">
          <rect width="13.9998" height="16.116" fill="white" transform="translate(0.5 0.442383)" />
        </clipPath>
      </defs>
    </svg>
  );
};
